import {Injectable} from '@angular/core';

import {environment} from '../../../environments/environment';

@Injectable()
export class UtilsService {

    constructor() {
    }

    public DateToString(inDate: Date, formatString: string) {
        const dateObject = {
            M: inDate.getMonth() + 1,
            d: inDate.getDate(),
            D: inDate.getDate(),
            h: inDate.getHours(),
            m: inDate.getMinutes(),
            s: inDate.getSeconds(),
            y: inDate.getFullYear(),
            Y: inDate.getFullYear()
        };
        // Build Regex Dynamically based on the list above.
        // Should end up with something like this "/([Yy]+|M+|[Dd]+|h+|m+|s+)/g"
        const dateMatchRegex = this.joinObj(dateObject, '+|') + '+';
        const regEx = new RegExp(dateMatchRegex, 'g');
        formatString = formatString.replace(regEx, (formatToken) => {
            const datePartValue = dateObject[formatToken.slice(-1)];
            let tokenLength = formatToken.length;

            if (formatToken.indexOf('y') < 0 && formatToken.indexOf('Y') < 0) {
                // Expand single digit format token 'd' to multi digit value '10' when needed
                tokenLength = Math.max(formatToken.length, datePartValue.toString().length);
            }
            const zeroPad = (datePartValue.toString().length < formatToken.length ? '0'.repeat(tokenLength) : '');
            return (zeroPad + datePartValue).slice(-tokenLength);
        });

        return formatString;
    }

    public joinObj(obj: any, seperator: string): string {
        const out = [];
        for (const k in obj) {
            out.push(k);
        }
        return out.join(seperator);
    }

    public debugLog(...args: any[]) {
        if (!environment.production) {
            console.log(args);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/utils.service.ts